import { ThemeTypographyKeys } from '@agria/theme/src/styles/tokens/typography';
import { ThemeBorderRadiiKeys } from '@agria/theme/src/styles/tokens/borderRadii';
import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';
import defaultTokens from '@agria/theme/src/styles/tokens/buttons';

interface ThemeButtonBase {
  color: ThemeColorsKeys;
  background: ThemeColorsKeys;
  borderColor: ThemeColorsKeys;
  borderRadius: ThemeBorderRadiiKeys;
  underline?: boolean;
  collapse?: boolean;
  upperCase?: boolean;
}

interface ThemeButton extends ThemeButtonBase {
  type: ThemeTypographyKeys;
  hover: ThemeButtonBase;
}

const primaryBase = {
  background: 'brandTwo100',
  color: 'utilityText',
  upperCase: true,
  hover: {
    background: 'brandTwo110',
    borderColor: 'brandTwo110',
  },
};

const buttons = {
  ...defaultTokens,
  primary: {
    borderColor: 'brandTwo100',
    ...primaryBase,
  },
  primaryOnDark: {
    borderColor: 'brandTwo100',
    ...primaryBase,
  },
  primaryOutline: {
    borderColor: 'brandOne',
    background: 'utilityWhite',
    color: 'brandOne',
    upperCase: true,
    hover: {
      borderColor: 'brandTwo110',
      background: 'brandTwo10',
      color: 'brandTwo110',
    },
  },
  secondary: {
    borderColor: 'brandOne',
    background: 'utilityWhite',
    color: 'brandOne',
    upperCase: true,
    hover: {
      borderColor: 'brandOne',
      background: 'brandOne10',
      color: 'brandOne',
    },
  },
  secondaryOutline: {
    borderColor: 'brandOne',
    background: 'utilityWhite',
    color: 'brandOne',
    upperCase: true,
    hover: {
      borderColor: 'brandOne',
      background: 'brandOne10',
      color: 'brandOne',
    },
  },
  secondaryInverse: {
    borderColor: 'utilityWhite',
    background: 'utilityWhite',
    color: 'brandOne100',
    upperCase: true,
    hover: {
      borderColor: 'brandOne100',
      background: 'brandOne100',
    },
  },
  secondaryInverseOutline: {
    borderColor: 'utilityWhite',
    background: 'transparent',
    color: 'utilityWhite',
    upperCase: true,
    hover: {
      borderColor: 'utilityWhite',
      background: 'utilityWhite',
      color: 'brandOne100',
    },
  },
  whiteOutline: {
    borderColor: 'brandTwo100',
    background: 'utilityWhite',
    color: 'brandTwo100',
    upperCase: true,
    hover: {
      borderColor: 'brandTwo110',
      background: 'brandTwo10',
      color: 'brandTwo110',
    },
  },
} as const;

export default buttons;

export type ThemeButtonKeys = keyof typeof buttons;
export type ThemeButtons = Record<ThemeButtonKeys, ThemeButton>;
